import svg from './Logo.svg';

export const Logo = () => <img src={svg} alt="Agoric Dashboard" />;
